"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pluralize = _interopRequireDefault(require("pluralize"));

var _Input = _interopRequireDefault(require("../../Input"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _useClickOutside = _interopRequireDefault(require("../../../hooks/useClickOutside"));

var _DurationOverlay = _interopRequireDefault(require("./DurationOverlay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: 100% !important;\n\t@media (min-width: ", ") {\n\t\twidth: 170px !important;\n\t}\n\n\t", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var buildDisplayValue = function buildDisplayValue(units, _ref) {
  var minutes = _ref.minutes,
      hours = _ref.hours;
  var text = [];

  if (units.includes('hours')) {
    text.push(hours + " " + (0, _pluralize.default)('hr', hours));
  }

  if (units.includes('minutes')) {
    text.push(minutes + " " + (0, _pluralize.default)('min', minutes));
  }

  return text.join(' ');
};

var Container = _styledComponents.default.div(_templateObject());

Container.displayName = 'Container';
var FlexibleInput = (0, _styledComponents.default)(_Input.default)(_templateObject2(), _breakpoints.default.tablet, function (props) {
  return props.hasFocus && "\n\t\tborder-color: " + _colors.default.borderFocus + " !important;\n\t\tbox-shadow: " + _vars.default.boxShadow + ";\n\t";
});
FlexibleInput.displayName = 'FlexibleInput';

var DurationPicker = function DurationPicker(_ref2) {
  var onChange = _ref2.onChange,
      units = _ref2.units,
      value = _ref2.value,
      min = _ref2.min,
      max = _ref2.max,
      minuteIncrements = _ref2.minuteIncrements,
      hourIncrements = _ref2.hourIncrements,
      GA = _ref2.GA,
      rest = _objectWithoutPropertiesLoose(_ref2, ["onChange", "units", "value", "min", "max", "minuteIncrements", "hourIncrements", "GA"]);

  var _useState = (0, _react.useState)(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var nodeRef = (0, _useClickOutside.default)(function () {
    return setFocus(false);
  });
  return _react.default.createElement(Container, {
    ref: nodeRef
  }, _react.default.createElement(FlexibleInput, _extends({
    readOnly: true,
    value: buildDisplayValue(units, value),
    onFocus: function onFocus() {
      return setFocus(true);
    },
    hasFocus: focus
  }, rest)), focus && _react.default.createElement(_DurationOverlay.default, {
    units: units,
    value: value,
    onHide: function onHide() {
      return setFocus(false);
    },
    onChange: onChange,
    min: min,
    max: max,
    hourIncrements: hourIncrements,
    minuteIncrements: minuteIncrements,
    GA: GA
  }));
};

var duration = (0, _propTypes.shape)({
  hours: _propTypes.number,
  minutes: _propTypes.number
});
DurationPicker.propTypes = {
  value: duration,
  units: (0, _propTypes.arrayOf)(_propTypes.string),
  onChange: _propTypes.func.isRequired,
  min: duration,
  max: duration,
  minuteIncrements: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),
  hourIncrements: _propTypes.number,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    action: _propTypes.string
  })
};
DurationPicker.defaultProps = {
  value: {
    hours: 0,
    minutes: 0
  },
  units: ['hours', 'minutes'],
  min: {
    hours: 0,
    minutes: 0
  },
  max: null,
  minuteIncrements: 1,
  hourIncrements: 1,
  GA: undefined
};
var _default = DurationPicker;
exports.default = _default;